import { router } from '../router/index';
import { getCredentials } from './utils';

export const invokeApi = async (
  pathParams,
  pathTemplate,
  method,
  additionalParams,
  body
) => {

  /* 
    get Cognito getCredentials 
    header authentication
    Authorization : tokenId||token
  */

  const apiURL = process.env.VUE_APP_API_ENDPOINT;
  const publicAPI = ['q', 'unsubscribe', 'increase-protect-code-usage-count', 'clientRecords', 'full-campaigninfo', 'clients', 'customFields', 'landingPages', 'formBuilder', 'metadata', 'formBuilderResults'];
  let authorizationToken;
  let cn2Path = pathTemplate.split('/').length > 0 ? pathTemplate.split('/')[1] : pathTemplate;
  if (publicAPI.indexOf(cn2Path) > -1) {
    authorizationToken = 'public';
  } else {
    let cognitoToken = getCredentials();
    authorizationToken = `${cognitoToken.tokenId}||${cognitoToken.token}`;
  }
  let cn2Headers = new Headers();
  cn2Headers.append('Authorization', authorizationToken);

  /* query string */
  let queryString = '', result = {};
  if (additionalParams.queryParams && additionalParams.queryParams.params) {
    queryString = `?params=${encodeURIComponent(additionalParams.queryParams.params)}`;
  }

  let requestOptions = {
    method: method,
    headers: cn2Headers
  };

  if (method === 'POST' || method === 'PUT') {
    requestOptions['body'] = JSON.stringify(body);
  }
  try {
    result = await fetchAPI(apiURL + pathTemplate + queryString, requestOptions);
    if (result.status === 400) {
      localStorage.clear();
      alert('Your session is already expired. Please Login and Logout again.');
      router.push('/login');
    }
  } catch (err) {
    result = {
      body: 'Your session is already expired. Please Login and Logout again.'
    }
  }
  return {
    data: result.body
  }
};

const fetchAPI = (url, options) => {
  return fetch(url, options)
    .then(response => response.json())
    .then(response => {
      return {
        status: 200,
        body: response
      }
    }).catch(err => {
      return {
        status: 400,
        body: err
      }
    })
}

export const apigClient = {
  invokeApi
};